import * as tslib_1 from "tslib";
import { saveReadingPaneOptionQuick } from '../actions/saveReadingPaneOption';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { getUserConfiguration } from 'owa-session-store';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
var ReadingPaneQuick = /** @class */ (function (_super) {
    tslib_1.__extends(ReadingPaneQuick, _super);
    function ReadingPaneQuick() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            var newReadingPanePosition = parseInt(option.key, 10);
            saveReadingPaneOptionQuick(newReadingPanePosition);
        };
        return _this;
    }
    ReadingPaneQuick.prototype.render = function () {
        var userOptions = this.props.userOptions;
        var options = [
            {
                key: "" + ReadingPanePosition.Right,
                text: strings.options_readingPane_quickSetting_right,
            },
            {
                key: "" + ReadingPanePosition.Bottom,
                text: strings.options_readingPane_quickSetting_bottom,
            },
            {
                key: "" + ReadingPanePosition.Off,
                text: strings.options_readingPane_quickSetting_classic,
            },
        ];
        return (React.createElement(ChoiceGroup, { "aria-labelledby": this.props.headerAriaId, selectedKey: "" + userOptions.GlobalReadingPanePositionReact, options: options, onChange: this.onChange }));
    };
    ReadingPaneQuick = tslib_1.__decorate([
        reactive({
            userOptions: function () { return getUserConfiguration().UserOptions; },
        })
    ], ReadingPaneQuick);
    return ReadingPaneQuick;
}(React.Component));
export default ReadingPaneQuick;
//# sourceMappingURL=ReadingPaneQuick.js.map